import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../contexts/TranslationContext";
import "../../assets/css/login.scss";
import api from "../../utils/api";

const ForgotPassword = () => {
  const { language } = useTranslation();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post(
        `${global.config.api.domain}/fwiq-api/api/account/forgotpassword`,
        { username, email }
      );

      if (response.status === 200) {
        setMessage(language.forgotPassword?.resetSuccess || "A reset token has been sent to your email.");
        setError("");
      } else {
        setError(response.data?.message || language.forgotPassword?.resetError || "Failed to send reset token.");
        setMessage("");
      }
    } catch (err) {
      console.error("Error during forgot password request:", err);
      const errMsg = err.response?.data?.message || language.forgotPassword?.genericError || "An error occurred. Please try again later.";
      setError(errMsg);
      setMessage("");
    }
  };

  return (
    <div className="forgot-password">
      <h1>{language.forgotPassword?.title || "Forgot Password"}</h1>

      <div className="forgot-password-box">
        <form onSubmit={handleForgotPassword}>
          <div className="forgot-password-item">
            <div className="title-item">
              <label htmlFor="username">{language.forgotPassword?.username || "Username"}</label>
            </div>
            <div className="textbox">
              <input
                type="text"
                id="username"
                placeholder={language.forgotPassword?.usernamePlaceholder || "Enter your username"}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="forgot-password-item">
            <div className="title-item">
              <label htmlFor="email">{language.forgotPassword?.email || "Email"}</label>
            </div>
            <div className="textbox">
              <input
                type="email"
                id="email"
                placeholder={language.forgotPassword?.emailPlaceholder || "Enter your email"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          {message && <div className="success-message">{message}</div>}
          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="btn btn-forgot-password">
            {language.forgotPassword?.sendResetToken || "Send Reset Token"}
          </button>
        </form>

        <div className="back-to-login">
          <p>
            <button
              className="link-button"
              onClick={() => navigate("../login")}
            >
              {language.forgotPassword?.backToLogin || "Back to Login"}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;